import { Component, OnInit, Renderer2, ElementRef, SimpleChanges, OnChanges, AfterViewInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UserService } from './core/user.service';
import { OldRoutesMapping } from './shared/models/old-route-mapping';
import { BlendService } from './shared/services/blend.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as fromRoot from './reducers';
import { SentryService } from './core/sentry.service';
import { UnauthBlendService } from './shared/services/unauthblend.service';
import { ChameleonService } from './shared/services/chameleon.service';
import { ShareService } from './shared/services/share.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'cp';
  routerSubscripion: Subscription;

  constructor(
    private renderer: Renderer2,
    private router: Router,
    private blendService: BlendService,
    private userService: UserService,
    private sanitizer: DomSanitizer,
    private store: Store<fromRoot.State>,
    private sentryService: SentryService,
    private unauthBlendService: UnauthBlendService,
    private chameleonService: ChameleonService,
    private shareService: ShareService,
  ) {
   }

  ngOnInit() {
    // By default Add the 'light' class to the body element
    this.renderer.addClass(document.body, 'light');
  }

  ngAfterViewInit():void {
    this.routerSubscripion = this.router.events.subscribe((routeEvent) => {
      if (routeEvent instanceof NavigationStart) {
          let newRoute = OldRoutesMapping(routeEvent.url);
          if (!newRoute && routeEvent.url.includes('/files')) {
            newRoute = routeEvent.url;
          }
          if (!newRoute && routeEvent.url.includes('/starred')) {
            newRoute = routeEvent.url;
          }
          if (!newRoute && routeEvent.url.includes('/vault')) {
            newRoute = routeEvent.url;
          }
          const isExcluded = routeEvent.url.startsWith('/dl/') || routeEvent.url.startsWith('/comment-iframe/cm') || routeEvent.url.startsWith('/opt-out');
          if (isExcluded) {
            newRoute = routeEvent.url;
          }
          if (this.userService.isAuthenticated() && !isExcluded) {
            if (!environment.isDev) {
              if (this.userService.get('is_newui_disabled')) {
                window.location.href = environment.cphost + (newRoute || '');
              }
            }
          }
      }
      if (routeEvent instanceof NavigationEnd) {
        window.scrollTo(0, 0);
        if (!this.userService.isAuthenticated()) {
          // we only want to log 1% of all unauthenticated page views **unless** it's a shared folder invititation
          const isShareInvite = [
            '/shares',
            '/setuserinviteconsent',
            '/signup-share',
          ].some((term) => routeEvent.url.includes(term));
          if (isShareInvite) {
            this.unauthBlendService.trackPageview();
          } else {
            const shouldLogPageView = Math.random() < 0.01;
            if (shouldLogPageView) {
              const isExcluded = routeEvent.url.startsWith('/dl/'); // unauthenticated publink views result in a lot of logging in Mixpanel
              if (!isExcluded) {
                this.unauthBlendService.trackPageview();
              }
            }
          }
        } else {
          this.blendService.trackPageview();
        }
      }
    });
    this.chameleonService.identify();
    if (this.userService.isAuthenticated()) {
      this.shareService.updateTheme();
    }
  }

  ngOnDestroy(): void {
    if (this.routerSubscripion) {
      this.routerSubscripion.unsubscribe();
    }
  }

}
